<template>
    <section class="recipe-no-results" aria-live="polite">
        <h2 class="recipe-no-results__title">No Results</h2>
        <p class="recipe-no-results__message">
            {{ noResultsMessage }}<br />
            Let's try something else
        </p>
        <button type="button" class="recipe-no-results__clear" @click="$emit('clear')">
            Clear Sort
        </button>
    </section>
</template>

<script>
    export default {
        props: {
            searchTerm: {
                type: String,
                default: '',
            },
        },
        computed: {
            noResultsMessage() {
                const searchTerm = this.searchTerm.trim();

                return searchTerm
                    ? `We couldn't find any matches for '${searchTerm}'`
                    : "We couldn't find any matches for the selected filters.";
            },
        },
    };
</script>
